"use client";

import apiFetch from "@/lib/fetch";
import TrainerCard, { TrainerLoading } from "../../../worker/TrainerCard";
import { useEffect, useState } from "react";
import { DEFAULT_DATA_LIMIT } from "@/@core/constants/pagination";
import InfiniteScroll from "@/components/InfiniteScroll";

export default function FeaturedTrainersClient({initialData}) {
  const [isLoading, setIsLoading] = useState(true);
  const [featuredTrainers, setFeaturedTrainers] = useState<any[]>(initialData);
  const [hasMore, setHasMore] = useState(true);

  const fetchData = async (index = 0) => {
    setIsLoading(true);
    const res = await apiFetch({
      route: `trainer/featured?index=${index}`,
    });
    if (res.length < DEFAULT_DATA_LIMIT) {
      setHasMore(false);
    }
    setIsLoading(false);

    return res;
  };

  const next = (page: number) => {
    fetchData(page).then((data) => {
      setFeaturedTrainers([...featuredTrainers, ...data]);
    });
  };

  if (!Array.isArray(featuredTrainers) || !featuredTrainers) return <></>;

  if (!Array.isArray(featuredTrainers) || !featuredTrainers.length)
    return <></>;

  return (
    <>
      <InfiniteScroll
        hasMore={hasMore}
        next={next}
        loading={
          <div className="container" id="trainer-client-card-skeleton">
            <TrainerLoading count={6} />
          </div>
        }
        isLoading={isLoading}
        skeletonElementId="trainer-client-card-skeleton"
        dataLength={featuredTrainers?.length || 0}
      >
        {featuredTrainers.map(
          (item: any) => item && <TrainerCard key={item.id} {...item} />,
        )}
      </InfiniteScroll>
    </>
  );
}
